import React, { useState, useContext } from 'react';
import { faGithub, faMediumM, faTwitter, faTelegram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NativeTokenPriceContext } from '../../../context/nativeTokenPrice';
// import TransactionsInfo  from './components/TransactionsInfo';

import { getAddress, nativeTokenName } from '../../../utils/commons';

import './Footer.css';

const Footer = () => {
  const { nativeTokenPrice } = useContext(NativeTokenPriceContext);

  const [isActive, setIsActive] = useState(false);

  const nativeTokenAddress = getAddress(process.env.REACT_APP_NATIVE_TOKEN);

  const toggleMenu = (evt) => {
    evt.preventDefault();
    setIsActive(!isActive);
  }

  const blurOnClick = (evt) => {
    evt.target.blur();
    if (isActive) {
      setIsActive(prevState => !prevState);
    }
  }

  return (
    <nav className="navbar is-fixed-bottom" role="navigation" aria-label="main navigation">
      <div className="container is-fluid">
        <div className="navbar-brand">
          <a href={ (process.env.REACT_APP_NATIVE_PRICE_LINK || '#').replace(':token', nativeTokenAddress) } className="navbar-item brand-title is-hidden-desktop" target="_blank" rel="noreferrer">
            <figure className="image is-24x24">
              <img src={ `/images/farms/${process.env.REACT_APP_NATIVE_TOKEN}.png` } alt={ nativeTokenName } />
            </figure>
            <span className="ml-1">${ nativeTokenPrice.amount.toFixed(3) }</span>
          </a>

          <button type="button" className={`navbar-burger ${isActive ? 'is-active' : null}`} aria-label="menu" aria-expanded="false" data-target="footerNavbar" onClick={ toggleMenu }>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div id="footerNavbar" className={ `navbar-menu ${isActive ? 'is-active' : null}` }>
          <div className="navbar-start">
            <a href="https://github.com/sandmanfinance" target="_blank" rel="noreferrer" className="navbar-item">
              <span className="icon-text">
                <span className="icon">
                  <FontAwesomeIcon icon={ faGithub } size="lg" />
                </span>
                <em className="is-hidden-desktop">
                  GitHub
                </em>
              </span>
            </a>
            <a href="https://docs.death.sandman.finance/" target="_blank" rel="noreferrer" className="navbar-item">
              <span className="icon-text">
                <span className="icon">
                  <FontAwesomeIcon icon={ faBook } size="lg" />
                </span>
                <em className="is-hidden-desktop">
                  Docs
                </em>
              </span>
            </a>
            <a href="https://sandmanfinance.medium.com/" target="_blank" rel="noreferrer" className="navbar-item">
              <span className="icon-text">
                <span className="icon">
                  <FontAwesomeIcon icon={ faMediumM } size="lg" />
                </span>
                <em className="is-hidden-desktop">
                  Medium
                </em>
              </span>
            </a>
            <a href="https://www.youtube.com/channel/UCN_deX0boZPVUre-SV6aqwA" target="_blank" rel="noreferrer" className="navbar-item">
              <span className="icon-text">
                <span className="icon">
                  <FontAwesomeIcon icon={ faYoutube } size="lg" />
                </span>
                <em className="is-hidden-desktop">
                  Videos
                </em>
              </span>
            </a>
            <a href="https://twitter.com/sandman_finance" target="_blank" rel="noreferrer" className="navbar-item">
              <span className="icon-text">
                <span className="icon">
                  <FontAwesomeIcon icon={ faTwitter } size="lg" />
                </span>
                <em className="is-hidden-desktop">
                  Twitter
                </em>
              </span>
            </a>
            <div className="navbar-item has-dropdown is-hoverable has-dropdown-up">
              <div className="navbar-link is-arrowless">
                <span className="icon-text">
                  <span className="icon">
                    <FontAwesomeIcon icon={ faTelegram } size="lg" />
                  </span>
                  <em className="is-hidden-desktop">
                    Telegram
                  </em>
                </span>
              </div>

              <div className="navbar-dropdown">
                <a href="https://t.me/SandMan_Finance" target="_blank" rel="noreferrer" className="navbar-item">
                  Official
                </a>
                <a href="https://t.me/SandMan_Finance" target="_blank" rel="noreferrer" className="navbar-item">
                  Announcements
                </a>
              </div>
            </div>

            <a href="https://metamask.sandman.finance/" target="_blank" rel="noreferrer" className="navbar-item">
              <figure className="image is-24x24">
                <img src="/images/metamask.svg" alt="Metamask" />
              </figure>
              <em className="is-hidden-desktop">
                Metamask
              </em>
            </a>

            {/* <TransactionsInfo/> */}
          </div>
          <div className="navbar-end">
            <a href="/" target="_blank" rel="noreferrer" className="navbar-item" onClick={ blurOnClick }>
              <em className="has-text-weight-bold">RugDoc</em> <span className="tag is-info is-rounded ml-1">pending</span>
            </a>
            <a href="https://audit.sc/audits/death-token-audit-review/" target="_blank" rel="noreferrer" className="navbar-item" onClick={ blurOnClick }>
              <em className="has-text-weight-bold">SC.Audit</em> <span className="tag is-success is-rounded ml-1">KYC / LOW RISK</span>
            </a>
            <div className="navbar-item">
              <span className="tag is-warning is-rounded ml-1">Original Artwork</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Footer;
